import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import {
  HomeIcon,
  UserGroupIcon,
  CalendarIcon,
  CurrencyRupeeIcon,
  CubeIcon,
  ChartBarIcon,
  BuildingStorefrontIcon,
  BanknotesIcon,
  BookOpenIcon,
  ClipboardDocumentListIcon,
  StarIcon,
  Cog6ToothIcon
} from '@heroicons/react/24/outline';

import { useAuth } from '../../contexts/AuthContext';

import Sidebar from './Sidebar';
import Navbar from './Navbar';

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user, signOut, role } = useAuth();


  const navigation = role === 'rep'
    ? [
        { name: 'Visits', href: '/visits', icon: CalendarIcon }
      ]
    : [
        { name: 'Dashboard', href: '/', icon: HomeIcon },
        { name: 'Visits', href: '/visits', icon: CalendarIcon },
        { name: 'Sales', href: '/sales', icon: CurrencyRupeeIcon },
        { name: 'Inventory', href: '/inventory', icon: ChartBarIcon },
        { name: 'Cash Flow', href: '/cash-flow', icon: BanknotesIcon },
        { name: 'Ledger', href: '/ledger', icon: BookOpenIcon },
        { name: 'Cycle Planning', href: '/cycle-planning', icon: ClipboardDocumentListIcon },
        { name: 'Core Doctors', href: '/kol', icon: StarIcon },
        { name: 'Doctors', href: '/doctors?type=doctor', icon: UserGroupIcon },
        { name: 'Chemists', href: '/doctors?type=chemist', icon: BuildingStorefrontIcon },
        { name: 'Products', href: '/products', icon: CubeIcon },
        { name: 'Companies', href: '/settings/companies', icon: Cog6ToothIcon }
      ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Sidebar
        navigation={navigation}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
      />

      <div className="lg:pl-64">

        {/* Top bar */}
        <Navbar user={user} signOut={signOut} setSidebarOpen={setSidebarOpen} />

        {/* Page content */}
        <main className="py-6">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;